import { render, staticRenderFns } from "./taskResult.vue?vue&type=template&id=6d833b96"
import script from "./taskResult.vue?vue&type=script&lang=js"
export * from "./taskResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports